import { ValidationRule } from 'react-hook-form';

// #region hook form veirfy
export enum FormVerifyEnum {
  必填 = 'required',
}

export const FormVerify: Record<
  FormVerifyEnum,
  Record<FormVerifyEnum, string>
> = {
  [FormVerifyEnum.必填]: { [FormVerifyEnum.必填]: '請填寫這個欄位。' },
};
// #endregion hook form veirfy

// #region hook form pattern veirfy
export enum FormPatternVerifyEnum {
  數字 = 'number',
  網址 = 'url',
  英文 = 'english',
  EMAIL = 'EMAIL', // (這是前專案的，需在跟現在的後端確認，驗證規則是否一致)
  統編 = 'ban',
  金額 = 'amount', // 若要求金額，要大於0，需搭配 validate: (value) => (value && value <= 0 ? '金額需大於0' : undefined),
  密碼規則 = 'password_rule',
  銀行帳號 = 'bank_account',
  數字英文 = 'engnum',
  單據號碼 = 'document number',
}

export const FormPatternVerify: Record<
  FormPatternVerifyEnum,
  ValidationRule<RegExp>
> = {
  [FormPatternVerifyEnum.數字英文]: {
    value: /^[A-Za-z0-9]+$/i,
    message: '請輸入英文/數字',
  },
  [FormPatternVerifyEnum.數字]: { value: /^[0-9]+$/, message: '請輸入數字' },
  [FormPatternVerifyEnum.網址]: {
    value:
      /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/i,
    message: '請確認網址格式，以https開頭',
  },
  [FormPatternVerifyEnum.英文]: {
    value:
      // 允許空白以及部分特殊符號，排除+=
      // eslint-disable-next-line no-irregular-whitespace
      /^[a-zA-Z0-9\uFF10-\uFF19\uFF41-\uFF5A\uFF21-\uFF3A_()&amp;＆＿～－.,．－~!@#$%^&*(),\s　-]+$/,
    message: '請輸入英文',
  },
  [FormPatternVerifyEnum.EMAIL]: {
    value:
      /^\w+((-\w+)|(\.\w+)|(\+\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/,
    // /^\w+((-\w+)|(\.\w+)|(\+\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/,
    message: 'Email 格式錯誤',
  },
  [FormPatternVerifyEnum.統編]: {
    value: /^[0-9]{8}$/,
    message: '請輸入 8 位數字',
  },
  [FormPatternVerifyEnum.金額]: { value: /^[0-9]+$/, message: '請輸入數字' },
  [FormPatternVerifyEnum.密碼規則]: {
    value: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,20}$/,
    message: '密碼不符合規則，請依密碼規則設定',
  },
  [FormPatternVerifyEnum.銀行帳號]: {
    value: /^[0-9]{8,16}$/,
    message: '帳號請輸入數字，長度介於8~16之間',
  },
  [FormPatternVerifyEnum.單據號碼]: {
    value: /^[A-Za-z0-9\\-]+$/i,
    message: '僅接受英文數字及-符號',
  },
};
// #endregion hook form pattern veirfy
